module.exports = __webpack_public_path__ + "static/pathways-customer-service-0dda02380fb990c194a75e9573ad763c.jpg";